{% block jga_revocation_consent_list %}
    <div class="jga-revocation-consent-list">
        <div v-if="items.length === 0" class="jga-revocation-consent-list__empty">
            {{ $tc('jga-revocation.consentList.empty') }}
        </div>

        <table v-else class="jga-revocation-consent-list__table">
            <thead>
                <tr>
                    <th class="jga-revocation-consent-list__col-order"></th>
                    <th>{{ $tc('jga-revocation.consentList.colPreview') }}</th>
                    <th class="jga-revocation-consent-list__col-flag">{{ $tc('jga-revocation.consentList.colRequired') }}</th>
                    <th class="jga-revocation-consent-list__col-flag">{{ $tc('jga-revocation.consentList.colActive') }}</th>
                    <th class="jga-revocation-consent-list__col-actions"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" :key="item.id" :class="{ 'is-inactive': !item.active }">
                    <td class="jga-revocation-consent-list__col-order">
                        <sw-button-group>
                            <sw-button size="x-small" :disabled="index === 0" @click="moveUp(index)">
                                <sw-icon name="regular-chevron-up-xs" small></sw-icon>
                            </sw-button>
                            <sw-button size="x-small" :disabled="index === items.length - 1" @click="moveDown(index)">
                                <sw-icon name="regular-chevron-down-xs" small></sw-icon>
                            </sw-button>
                        </sw-button-group>
                    </td>
                    <td class="jga-revocation-consent-list__col-preview">{{ labelPreview(item) }}</td>
                    <td class="jga-revocation-consent-list__col-flag">
                        <sw-switch-field
                            :value="item.required"
                            @change="setRequired(index, $event)"
                            @update:value="setRequired(index, $event)"
                        ></sw-switch-field>
                    </td>
                    <td class="jga-revocation-consent-list__col-flag">
                        <sw-switch-field
                            :value="item.active"
                            @change="setActive(index, $event)"
                            @update:value="setActive(index, $event)"
                        ></sw-switch-field>
                    </td>
                    <td class="jga-revocation-consent-list__col-actions">
                        <button
                            type="button"
                            class="jga-revocation-consent-list__action-btn"
                            :title="$tc('jga-revocation.consentList.actionEdit')"
                            @click="editItem(index)"
                        >
                            <sw-icon name="regular-pencil-s" small></sw-icon>
                        </button>
                        <button
                            type="button"
                            class="jga-revocation-consent-list__action-btn jga-revocation-consent-list__action-btn--danger"
                            :title="$tc('jga-revocation.consentList.delete')"
                            @click="askDelete(index)"
                        >
                            <sw-icon name="regular-trash" small></sw-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="jga-revocation-consent-list__add">
            <sw-button variant="ghost" @click="addItem">
                <sw-icon name="regular-plus-circle" small></sw-icon>
                {{ $tc('jga-revocation.consentList.addEntry') }}
            </sw-button>
        </div>

        <sw-modal
            v-if="editingItem"
            :title="$tc('jga-revocation.consentList.modalTitle')"
            variant="large"
            @modal-close="cancelEdit"
        >
            <div class="jga-revocation-consent-list__modal">
                <sw-single-select
                    class="jga-revocation-consent-list__locale-select"
                    :value="activeLocale"
                    :options="languageOptions"
                    :label="$tc('jga-revocation.consentList.language')"
                    show-clearable-button="false"
                    @update:value="activeLocale = $event"
                ></sw-single-select>

                <div class="jga-revocation-consent-list__editor">
                    <sw-text-editor
                        :value="labelForLocale(activeLocale)"
                        :label="$tc('jga-revocation.consentList.labelText')"
                        :sanitize-input="false"
                        @input="updateLabelForLocale(activeLocale, $event)"
                        @update:value="updateLabelForLocale(activeLocale, $event)"
                    ></sw-text-editor>
                </div>

                <div class="jga-revocation-consent-list__flags">
                    <sw-switch-field
                        v-model:value="editingItem.displayAsText"
                        :label="$tc('jga-revocation.consentList.flagDisplayAsText')"
                        :helpText="$tc('jga-revocation.consentList.flagDisplayAsTextHelp')"
                    ></sw-switch-field>
                    <sw-switch-field
                        v-model:value="editingItem.required"
                        :label="$tc('jga-revocation.consentList.flagRequired')"
                        :disabled="editingItem.displayAsText"
                    ></sw-switch-field>
                    <sw-switch-field
                        v-model:value="editingItem.active"
                        :label="$tc('jga-revocation.consentList.flagActive')"
                    ></sw-switch-field>
                </div>
            </div>

            <template #modal-footer>
                <sw-button variant="ghost" @click="cancelEdit">
                    {{ $tc('jga-revocation.consentList.cancel') }}
                </sw-button>
                <sw-button variant="primary" @click="saveEdit">
                    {{ $tc('jga-revocation.consentList.save') }}
                </sw-button>
            </template>
        </sw-modal>

        <sw-modal
            v-if="confirmDeleteIndex !== null"
            :title="$tc('jga-revocation.consentList.deleteTitle')"
            variant="small"
            @modal-close="cancelDelete"
        >
            <p>{{ $tc('jga-revocation.consentList.deleteConfirmation') }}</p>
            <template #modal-footer>
                <sw-button variant="ghost" @click="cancelDelete">
                    {{ $tc('jga-revocation.consentList.cancel') }}
                </sw-button>
                <sw-button variant="danger" @click="confirmDelete">
                    {{ $tc('jga-revocation.consentList.delete') }}
                </sw-button>
            </template>
        </sw-modal>
    </div>
{% endblock %}
